import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function ContactSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    tipo: 'Soy el titular ( Adulto Mayor )',
    mensaje: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  // Reemplazá este número por el WhatsApp real de la residencia
  // Formato: código de país + área + número, sin espacios ni símbolos
  // Ejemplo Argentina: 549343XXXXXXX
  const WHATSAPP_NUMBER = '543436218477';
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `*Nueva consulta - Vínculos de Vida*%0A%0A` + `*Nombre:* ${formData.nombre}%0A` + `*Teléfono:* ${formData.telefono}%0A` + `*Tipo de consulta:* ${formData.tipo}%0A` + `*Mensaje:* ${formData.mensaje || '(sin mensaje adicional)'}`;
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
    setFormData({
      nombre: '',
      telefono: '',
      tipo: 'Soy el titular ( Adulto Mayor )',
      mensaje: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <section id="contacto" className="py-[100px] px-5 md:px-[5%] bg-white" data-id="element-22">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-24">
          <h2 className="text-verde-oscuro text-3xl md:text-[2.5rem] font-serif mb-5" data-id="element-25">
            Faltan detalles para abrir...
          </h2>
          <p className="text-lg font-sans text-texto mb-5" data-id="element-26">
            Pero puedes adelantarte. Estamos tomando entrevistas para{' '}
            <strong data-id="element-27">reservar los primeros cupos</strong> de nuestra próxima
            apertura.
          </p>
          <ul className="list-none space-y-3 text-lg font-sans" data-id="element-28">
            <li data-id="element-29">📌 Calle Arenales 169</li>
            <li data-id="element-30">📍 General Ramírez, Entre Ríos</li>
            <li data-id="element-31">✅ Consultas por disponibilidad y aranceles</li>
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-verde-oscuro p-8 md:p-10 rounded-[10px] text-white" data-id="element-32">
          <h3 className="text-2xl font-serif mb-6" data-id="element-33">Solicitar Información</h3>

          {isSubmitted ? <div className="bg-verde-vida/20 border border-white/30 text-white p-6 rounded-lg text-center font-sans" data-id="element-34">
              <h4 className="font-bold text-xl mb-2" data-id="element-35">¡Abriendo WhatsApp!</h4>
              <p data-id="element-36">
                Te redirigimos para que envíes tu consulta directamente. Si no
                se abre, revisá los permisos de tu navegador.
              </p>
            </div> : <form onSubmit={handleSubmit} className="font-sans space-y-4" data-id="element-37">
              <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} placeholder="Tu nombre completo" required className="w-full p-4 border-none rounded-md text-texto focus:outline-none focus:ring-2 focus:ring-dorado" data-id="element-38" />

              <input type="tel" name="telefono" value={formData.telefono} onChange={handleChange} placeholder="Tu Celular (WhatsApp)" required className="w-full p-4 border-none rounded-md text-texto focus:outline-none focus:ring-2 focus:ring-dorado" data-id="element-39" />

              <select name="tipo" value={formData.tipo} onChange={handleChange} className="w-full p-4 border-none rounded-md text-texto focus:outline-none focus:ring-2 focus:ring-dorado" data-id="element-40">
                <option data-id="element-41">Soy el titular ( Adulto Mayor )</option>
                <option data-id="element-42">Busco información para un familiar</option>
              </select>

              <textarea name="mensaje" value={formData.mensaje} onChange={handleChange} rows={4} placeholder="¿Tienes alguna consulta específica?" className="w-full p-4 border-none rounded-md text-texto focus:outline-none focus:ring-2 focus:ring-dorado resize-y" data-id="element-43"></textarea>

              <button type="submit" className="w-full p-4 bg-dorado text-white border-none rounded-md text-[1.1rem] font-bold cursor-pointer transition-colors hover:bg-dorado/90 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-dorado/50" data-id="element-44">
                ENVIAR Y RESERVAR TURNO
              </button>
            </form>}
        </motion.div>
      </div>
    </section>;
}